import axios from "axios";

const axiosInstance = axios.create();

// Add a request interceptor to include the auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const message = (error.response?.data?.message || "").toLowerCase();
    const isInactive = message.includes("inactive") || message.includes("not active") || message.includes("desbled your profile");
    if (status === 401 || (status === 403 && isInactive)) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminRole");
      localStorage.removeItem("adminProfile");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
